// Need to match icons in utility
export const STATUS = {
  DISABLE: 'DISABLE',
  AVAILABLE: 'AVAILABLE',
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  LOCKED: 'LOCKED',
}

export const SPORTS = {
  SNOWBOARD: 'SNOWBOARD',
  SKI: 'SKI',
  MOUNTAIN_BIKE: 'MOUNTAIN_BIKE',
  WATER_SPORTS: 'WATER_SPORTS',
  OTHERS: 'OTHERS',
}

export const RELATIONS = {
  SELF: 'SELF',
  SPOUSE: 'SPOUSE',
  PARTNER: 'PARTNER',
  CHILD: 'CHILD',
  PARENT: 'PARENT',
  OTHER: 'OTHER',
}

export const SKILL_LEVELS = {
  NO_EXPERIENCE: 'NO_EXPERIENCE',
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
}

export const LOCATIONS = [
  { value: 'Sommet Edelweiss', label: 'Sommet Edelweiss' },
  { value: 'Calabogie Peaks Resort', label: 'Calabogie Peaks Resort' },
  { value: 'Mont Ste. Marie', label: 'Mont Ste. Marie' },
  { value: 'Ski Vorlage', label: 'Ski Vorlage' },
  { value: 'Mont Tremblant', label: 'Mont Tremblant' },
  { value: 'Mont Cascades', label: 'Mont Cascades' },
  { value: 'Mount Pakenham', label: 'Mount Pakenham' },
  { value: 'Mont Sainte-Anne', label: 'Mont Sainte-Anne' },
  { value: 'Whistler Blackcomb', label: 'Whistler Blackcomb' },
  { value: 'Other', label: 'Other' },
]

export const CERTIFICATIONS = [
  'CASI Carving Instructor',
  'CASI Evaluator L1',
  'CASI Evaluator L2',
  'CASI Evaluator L3',
  'CASI Evaluator L4',
  'CASI L1',
  'CASI L2',
  'CASI L3',
  'CASI L4',
  'CASI Park 1 Evaluator',
  'CASI PARK 1 Instructor',
  'CASI Park 2 Evaluator',
  'CASI PARK 2 Instructor',
  'CSIA Course Conductor L1',
  'CSIA L1',
  'CSIA L2',
  'CSIA L3 Partial (Ski)',
  'CSIA L3 Partial (Teach)',
  'CSIA L3',
  'CSIA L4 Partial (Ski)',
  'CSIA L4 Partial (Teach)',
  'CSIA L4',
]

export const CERTIFICATIONS_UPPER_CASE = CERTIFICATIONS.map((certificate) => certificate.toUpperCase())

export const ROLES = {
  MEMBER: 'MEMBER',
  INSTRUCTOR: 'INSTRUCTOR',
  ADMIN: 'ADMIN',
}

// Default Form Values
export const DEFAULT_FORM_VALUES = {
  // date: null,
  skiResort: '',
  sport: '',
  price: 75,
  capacity: 1,
  description: `Private Session Detail:

Individual: $75 per hour (ages 10 to 70), Same as base price
Paired: $105 per hour (for two students of similar level, ages 10 to 65)
Triple: $125 per hour (for three students of similar level, ages 10 to 65)

Ski pass and equipment are self-provided.

Each lesson includes a 5-minute transition period. For example, a one-hour lesson provides 55 minutes of actual instruction, a two-hour lesson provides 115 minutes, and so on. `,
  registrationDeadline: 4,
  cancellationDeadline: 24,
}

export const SESSION_TYPE = {
  PRIVATE: 'private',
  GROUP: 'group',
}

export const WAIVER_TEXT =
  'In hiring Greater Chinese Community Ski and Outdoor Club for club membership or guest participation, I agree that participation is voluntary. I recognize that certain risks including risk of personal injury, death, property damage, expense and related loss, including loss of income are attendant to outdoor activities and I assume those risks.    I do hereby waive and release any claims or rights against Greater Chinese Community Ski and Outdoor Club, its directors, officers, officials, trip guides, volunteers, other participants, owners of the facilities where the activities occur (referred to in the rest of this agreement as “THE CLUB AND OTHERS”) for any and all injury, damage, or loss to my person or property. THE CLUB AND OTHERS assume no responsibility for injury, damage or loss to a person or property incurred while participating in any Greater Chinese Community Ski and Outdoor Club activities or service.   I HAVE READ THIS AGREEMENT AND UNDERSTAND IT. I AM WAIVING CERTAIN RIGHTS WHICH I OR MY NEXT OF KIN, HEIRS, EXECUTORS, ADMINISTRATORS AND ASSIGNS MAY HAVE AGAINST THE CLUB AND OTHERS.'
